'use client';

import React from 'react';
import { useBenzingaEdge } from '@benzinga/edge';
import EconomicDataModule from './EconomicDataTable';
import CompanyEventsModule from './CompanyEventsModule';
import TopEarningsModule from './TopEarningsModule';
import AnalystUpgradesModule from './AnalystUpgradesModule';
import IPOsModule from './IPOsModule';
import PreMarketIndexesModule from './PreMarketIndexesModule';
import { MarketUpdateTableCTA } from './MarketUpdateTableCTA';
import moduleTableStyles from './ModuleTable.module.css';

const leftColumnModules: { key: string; module: React.ReactNode }[] = [
  { key: 'economic', module: <EconomicDataModule /> },
  { key: 'company-events', module: <CompanyEventsModule /> },
  { key: 'top-earnings', module: <TopEarningsModule /> },
  { key: 'analyst-upgrades', module: <AnalystUpgradesModule action="Upgrades" title="Analyst Upgrades" /> },
];

const rightColumnModules: { key: string; module: React.ReactNode }[] = [
  { key: 'premarket-indexes', module: <PreMarketIndexesModule /> },
  { key: 'ipos', module: <IPOsModule /> },
  {
    key: 'analyst-initiations',
    module: <AnalystUpgradesModule action="Initiates Coverage On" title="Analyst Initiations" />,
  },
  { key: 'analyst-downgrades', module: <AnalystUpgradesModule action="Downgrades" title="Analyst Downgrades" /> },
];

const TableWithCTA: React.FC<{ children: React.ReactNode; showOverlay: boolean }> = ({ children, showOverlay }) => (
  <div className="relative w-full">
    {children}
    {showOverlay && <MarketUpdateTableCTA />}
  </div>
);

export const MarketUpdatePageContent: React.FC = () => {
  const { hasEdgeSubscription, isEdgeSubscriptionLoading } = useBenzingaEdge();
  const showOverlay = !hasEdgeSubscription && !isEdgeSubscriptionLoading;

  return (
    <div className={showOverlay ? moduleTableStyles.blurRowsAfterFour : undefined}>
      <div className="market-update-content flex justify-between flex-wrap p-4 sm:p-8 lg:p-16">
        <div className="flex flex-col w-full lg:w-1/2 lg:pr-3">
          {leftColumnModules.map(({ key, module }) => (
            <TableWithCTA key={key} showOverlay={showOverlay}>
              {module}
            </TableWithCTA>
          ))}
        </div>
        <div className="flex flex-col w-full lg:w-1/2 lg:pl-3">
          {rightColumnModules.map(({ key, module }) => (
            <TableWithCTA key={key} showOverlay={showOverlay}>
              {module}
            </TableWithCTA>
          ))}
        </div>
      </div>
    </div>
  );
};
